module.exports = __webpack_public_path__ + "static/img/5d.c30a3b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/5d.jpg
// module id = CTmI
// module chunks = 0